import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20amber%20and%20cream%20abstract%20gradient%20with%20soft%20flowing%20shapes%2C%20minimalist%20modern%20design%2C%20gentle%20lighting%2C%20peaceful%20professional%20atmosphere%2C%20clean%20composition%2C%20no%20text&width=1800&height=600&seq=jm-cta-bg-02&orientation=landscape"
        alt="jm天堂CTA背景"
        className="absolute inset-0 w-full h-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-black/15"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          立即开始探索jm天堂
        </h2>
        <p className="text-background-200/90 text-base md:text-lg mb-10 max-w-xl mx-auto leading-relaxed">
          获取最新官方入口，畅享丰富内容资源。我们持续更新，确保您始终访问到正确的地址。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/article/jmtiantang-official-entry-2026"
            className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-external-link-line mr-2 text-lg"></i>
            获取最新入口
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto inline-flex items-center justify-center px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-base hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line mr-2 text-lg"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}